import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Layers } from '@helpers/layers';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.button) `
  ${ButtonReset};
  ${fonts.intro};

  display: flex;
  flex-direction: column;
  font-size: ${fluid(14, 18)};
  color: ${brand.global.black};
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${brand.secondary.yellow.light};
  border-radius: ${fluid(16, 24)} ${fluid(16, 24)} 0 0;
  margin: 0;
  padding: 4px 12px 8px;
  animation: pulse 5s infinite;
  transform-origin: bottom center;
  z-index: ${Layers.ScrollArrow};

  svg {
    width: ${fluid(20, 26)};
    animation: fadeOutIn 2.25s infinite;

    &:not(:last-of-type) {
      margin-bottom: calc(${fluid(12, 16)} * -1);
    }

    &:last-of-type {
      margin-bottom: 2px;
    }

    &:nth-child(2) {
      animation-delay: 250ms;
    }

    &:nth-child(3) {
      animation-delay: 500ms;
    }
  }

  @keyframes fadeOutIn {
    0% {
      opacity: 1;
    }
    20% {
      opacity: 0;
    }
    40% {
      opacity: 0;
    }
    80% {
      opacity: 1;
    }
  }

  @keyframes pulse {
    0% {
      scale: 1;
      filter: brightness(1);
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
    }
    20% {
      scale: 1.05;
      filter: brightness(1.05);
    }
    40% {
      scale: 1.05;
      filter: brightness(1.05);
      box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
    }
    80% {
      scale: 1;
      filter: brightness(1);
    }
  }
`;
const ScrollIndicatorStyles = {
    Container,
};
export default ScrollIndicatorStyles;
